import moment from "moment"
import { Fragment } from "react"
import henceforthApi from "../../utils/henceforthApi"
import profile_img from '../../assets/images/pages/defaultImage.jpg';
import { innerRating } from "../../pages/product/productInterface";
import { GlobalContext } from "../../context/Provider";
import React from "react";
import SignedImage from './SignedImage';
type ArrayType = {
    ratingArray: Array<innerRating>
}
export default (props: ArrayType) => {
    const { language_data, loading, setLoading, authState, authDispatch } = React.useContext(GlobalContext)
    return <div className="common-card h-100">
        <div className="common-card-title">
            <h5>{language_data?.[authState.lang]?.common_rating_reviews} </h5>
        </div>
        <div className="common-card-content">
            {/* 1  */}
            {Array.isArray(props?.ratingArray) && props?.ratingArray?.length ? props.ratingArray.map((res, index: number) => {
                let stared = [...Array(res?.ratings)].map((e, i) => <li key={i}><i className="fa fa-star text-warning"></i></li>)
                let staredOff = [...Array(5 - res?.ratings)].map((e, i) => <li key={i}><i className="fa fa-star text-muted"></i></li>)
                return (
                    <Fragment key={index}>
                        <div className='rating-box'>
                            <div className="rating-username product-image-table d-flex gap-2 mb-2">
                                <SignedImage
                                    src={(res as any)?.user?.profile_pic || (res as any)?.user_id?.profile_pic || (res as any)?.profile_pic || ''}
                                    className="border rounded-circle"
                                    alt="img"
                                    fallback={profile_img}
                                    size="medium"
                                />
                                <div>
                                    <p className='fw-bold'>{(res as any)?.user?.name || (res as any)?.user_id?.name || (res as any)?.user_name || (res as any)?.username || `${language_data?.[authState.lang]?.common_not_available}`}</p>
                                    <ul className='list-unstyled d-flex gap-1 rating-icons m-0'>
                                        {stared}{staredOff}
                                    </ul>
                                </div>
                            </div>
                            <div>

                                <p className='fw-bold'>{res?.title ? res?.title : `${language_data?.[authState.lang]?.common_not_available}`}</p>
                                <p className='my-1'> {res?.description ? res?.description : `${language_data?.[authState.lang]?.common_not_available}`} </p>
                                <p className='fw-bold'>
                                    {res?.updated_at
                                        ? moment(res.updated_at).utcOffset(330).format('MMMM Do YYYY')
                                        : "Not Available"}
                                </p>
                            </div>
                        </div>
                        <div className='divider my-3'></div>
                    </Fragment>
                )
            }) : <p>{language_data?.[authState.lang]?.common_not_available} </p>}
        </div>
    </div>
}